import { schoolScope } from '@/lib/query/scope'

/**
 * School: the signed-in user's membership row at one school (`SchoolProvider`).
 * The request (`GET /v1/users/me`) lists every membership; the query keeps the
 * one for the key's school, so the key's `schoolId` is the school it answers for.
 */
export const activeSchoolUserKeys = {
  detail: (schoolId: string | null, userId: string | null | undefined) =>
    [...schoolScope(schoolId), 'active-school-user', userId ?? null] as const
}
